/**
 * The fixed, Shape Up-inspired categories a Scratchpad list can be filed under.
 * The single source of truth shared by the page's tabs and each card's move
 * menu. `null` on a list means uncategorized (it lives only under "All").
 */
export const LIST_CATEGORIES = [
  { key: 'pitches', label: 'Pitches' },
  { key: 'cooldown', label: 'Cooldown' },
  { key: 'tech-debt', label: 'Tech Debt' },
  { key: 'ideas', label: 'Ideas' },
];

export const categoryLabel = (key) =>
  LIST_CATEGORIES.find(c => c.key === key)?.label || null;
